import { z } from "zod";
import { Family } from "./fullProductData.models";

// Zod schema representing an Akeneo model fetched from backend
export const AkeneoModelSchema = z
  .object({
    packageAssociations: z.record(z.string(), z.number()).nullable().optional(),
    ean: z.string().optional(),
    packageRowsAssociation: z.string().nullable(),
    modelAssociations: z.record(z.string(), z.number()),
    modelReverseAssociations: z.record(z.string(), z.number()),
    productAssociations: z.record(z.string(), z.number()),
    identifier: z.string(),
    name: z.string(),
    image: z.string().nullable().optional(), // optional and may be null
    companyId: z.union([z.string(), z.number()]).optional(),
    responsibleToReport: z.boolean().optional(),
    comment: z.string().optional(),
    internalReference: z.string().optional(),
  })
  .strict();

export type AkeneoModel = z.infer<typeof AkeneoModelSchema>;

export enum PackageType {
  Ecomodulation = "ecomod_consumer",
  EcomodulationBusiness = "ecomod_business",
  Simple = "simple_consumer",
  SimpleBusiness = "simple_business",
}

export const CreateAkeneoModelPayloadSchema = z
  .object({
    identifier: z.string(),
    name: z.string(),
    image: z.string().optional(),
    ean: z.string().optional(),
    family: z.nativeEnum(Family),
    packageRowsAssociation: z.string().nullable(),
    packageAssociations: z.record(z.string(), z.number()).nullable().optional(),
    modelAssociations: z.record(z.string(), z.number()).optional(),
    modelReverseAssociations: z.record(z.string(), z.number()).optional(),
    productAssociations: z.record(z.string(), z.number()).optional(),
    companyId: z.union([z.string(), z.number()]).optional(),
    responsibleToReport: z.boolean().optional(),
    comment: z.string().optional(),
    internalReference: z.string().optional(),
  })
  .strict();

export type CreateAkeneoModelPaylod = z.infer<
  typeof CreateAkeneoModelPayloadSchema
>;

export const UpdateAkeneoModelPayloadSchema = z
  .object({
    identifier: z.string(),
    name: z.string(),
    image: z.string().optional(),
    ean: z.string().optional(),
    family: z.nativeEnum(Family),
    packageRowsAssociation: z.string().nullable(),
    packageAssociations: z.record(z.string(), z.number()).nullable().optional(),
    modelAssociations: z.record(z.string(), z.number()).optional(),
    modelReverseAssociations: z.record(z.string(), z.number()).optional(),
    productAssociations: z.record(z.string(), z.number()).optional(),
    companyId: z.union([z.string(), z.number()]).optional(),
    responsibleToReport: z.boolean().optional(),
    comment: z.string().optional(),
    internalReference: z.string().optional(),
  })
  .strict();

export type UpdateAkeneoModelPaylod = z.infer<
  typeof UpdateAkeneoModelPayloadSchema
>;
